import React from "react";

type HeadStylingProps = {
    layout: TLayout;
}

export default class HeadStyling extends React.Component<HeadStylingProps> {
    render(): React.ReactNode {
        const fonts = this.props.layout?.texts_styles?.fonts || [];
        if (fonts.length === 0) return null;
        
        const elements = [];
        let index = 0;
        for (const font of fonts) {
            const fontPath = font.item.location ? font.item.location : `${font.item.family}/${font.item.family}`;
            if (font.item.variable) {
                elements.push(<link rel="preload" data-hsf href={`/fonts/${fontPath}.woff2`} as="font" type="font/woff2-variations" crossOrigin="anonymous" key={`font_${index++}`} />);
            } else {
                elements.push(<link rel="preload" data-hsf href={`/fonts/${fontPath}.woff2`} as="font" type="font/woff2" crossOrigin="anonymous" key={`font_${index++}`} />);
                elements.push(<link rel="preload" data-hsf href={`/fonts/${fontPath}.woff`} as="font" type="font/woff" crossOrigin="anonymous" key={`font_${index++}`} />);
            }
        }
        
        return elements;
    }
}